
import React from 'react';
import BasicReport from './BasicReport';
import StandardReport from './StandardReport';



const Analysis = ({ plan }) => {

  const subscriptionPlan = plan || localStorage.getItem("planType") || "standard";

  switch (subscriptionPlan.toLowerCase()) {
    case "basic":
      return <BasicReport />;
    case "standard":
      return <StandardReport />;
    case "premium":
      return <StandardReport />;
    default:
      return <div>Invalid plan selected</div>;
  }
};

export default Analysis;